import PortfolioItem from './PortfolioItem'

export default PortfolioItem
